module.exports = __webpack_public_path__ + "img/tanker_inactive.d07c2128.svg";